import React from 'react'
import { Button, Container, Grid, Heading, Image, Paragraph } from '@health-zelas/delta'

import Step from '../../components/Step'
import ProgressBar from "../../components/ProgressBar"

import resultImg from '../../images/result.png'

import * as S from './WaitForContact.styles'

const WaitForContact = () => (
  <Step>
    <Container>
      <Grid>
        <Grid.Item colSpans={{ sm: 12, md: 6, lg: 5 }}>
          <div>
            <ProgressBar title="Resultado" fill={4} lastStep="Concluído" />

            <Image
              src={resultImg}
              alt=""
              loading="eager"
              css={{
                width: '100%',
                borderRadius: '$md'
              }}
            />
          </div>
        </Grid.Item>

        <Grid.Item colStarts={{ md: 7 }} colEnds={{ md: 13 }}>
          <S.TextBlock>
            <Heading
              as="h1"
              size="lg"
              weight="bold"
              css={{
                marginBottom: '$xxs',

                '@md': {
                  marginBottom: '$xs',
                  marginTop: '$xxxxl'
                }
              }}
            >
              Tudo certo! <span role="img" aria-label="Emoji sorrindo">😁</span>
              <br />
              Agora é só aguardar o contato.
            </Heading>

            <Paragraph
              size="lg"
              color="$neutralDark"
              lineHeight="distant"
            >
              Em breve uma pessoa corretora da Qualicorp entrará em contato pra te ajudar a encontrar o plano de saúde ideal!
            </Paragraph>

            <Button
              as="a"
              href="https://saude.zelas.com.br"
              size="large"
              id="pagina_inicial_aguardar_contato_qualicorp"
              className="aguardar_contato_qualicorp"
              fullWidth={{
                '@xs': true,
                '@md': false
              }}
              css={{
                marginTop: '$md'
              }}
            >
              Ir para página inicial
            </Button>
          </S.TextBlock>
        </Grid.Item>
      </Grid>
    </Container>
  </Step>
)

export default WaitForContact
